import Vue from 'vue'
import { castDateToLocaleFormat } from '@shared/utils/date'
import { FORM_FIELD_TYPE } from '@shared/const/form/form.field'

export async function formSubmit(method, recaptchaToken, form, allFields, formOptions) {
  const action = formOptions.action
  const extraSubmitData = formOptions.extraSubmitData
  const extraFieldNames = formOptions.extraFieldNames
  const beforeSubmitFn = formOptions.beforeSubmitFn

  const rawData = { recaptchaToken: { value: recaptchaToken } }

  allFields.forEach(field => {
    rawData[field.name] = { typeField: field.typeField, value: field.value }
  })

  extraFieldNames.forEach(key => {
    if (form[key]) {
      rawData[key] = { value: form[key] }
    }
  })

  Object.keys(extraSubmitData).forEach(key => {
    rawData[key] = { value: extraSubmitData[key] }
  })

  const data = typeof beforeSubmitFn === 'function' ? beforeSubmitFn(rawData) : rawData

  const fd = getFormData(data)

  const response = await Vue.http[method](action, fd)
  return await response.json()
}

function getFormData(data) {
  const formData = new FormData()

  for (const name in data) {
    const value = data[name].value
    const typeField = data[name]?.typeField

    switch (typeField) {
      case FORM_FIELD_TYPE.STUB_TEXT:
        break

      case FORM_FIELD_TYPE.VIEW_HIDDEN:
        if (value) {
          formData.append(name, value)
        }
        break

      case FORM_FIELD_TYPE.DATE:
        formData.append(name, castDateToLocaleFormat(value))
        break

      case FORM_FIELD_TYPE.FILE:
        value.forEach(file => {
          formData.append(name, file)
        })
        break

      case FORM_FIELD_TYPE.DADATA_STRING_CITY:
        if (value) {
          formData.append(name, value.city)
        }
        break

      case FORM_FIELD_TYPE.DADATA_STRING_COMPANY:
        if (value) {
          for (const key in value) {
            switch (key) {
              case 'region':
                formData.append(`${name}[district]`, value[key])
                continue
              case 'federal_district':
              case 'region_with_type':
                continue
              default:
                formData.append(`${name}[${key}]`, value[key])
            }
          }
        }
        break

      default:
        if (Array.isArray(value)) {
          value.forEach($ => {
            formData.append(`${name}[]`, $)
          })
        } else if (value !== null && value !== undefined) {
          formData.append(name, value)
        }
    }
  }

  return formData
}



// WEBPACK FOOTER //
// ./src/modules/shared/services/form/form.submit.js